module.exports = __webpack_public_path__ + "img/clients-02.c06a8ba2.svg";